import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import { MIN_READING_TIME_IN_SECONDS } from './OfferSection.constants';
import { UseOfferSection } from './OfferSection.types';
import { sendOfferViewedEntirelyEvent } from './OfferSection.utils';

export const useOfferSection: UseOfferSection = ({
  companyName,
  offerCode
}) => {
  const { t } = useI18n('job-offer');
  const { locale } = useRouter();

  const [ref, inView] = useInView({
    // 50% of the element must be visible
    threshold: 0.5
  });

  const startReadingTime = useRef<number | undefined>(undefined);
  const readTrackingEventSent = useRef<boolean>(false);

  useEffect(() => {
    if (!inView || !startReadingTime.current) {
      return;
    }

    const now = Date.now();
    const readingTimeInSeconds = (now - startReadingTime.current) / 1000;
    const minReadingTimeReached =
      readingTimeInSeconds >= MIN_READING_TIME_IN_SECONDS;

    if (minReadingTimeReached && !readTrackingEventSent.current) {
      sendOfferViewedEntirelyEvent({
        companyName,
        offerCode,
        locale
      });

      readTrackingEventSent.current = true;
    }
  }, [inView, companyName, offerCode, locale]);

  useEffect(() => {
    startReadingTime.current = Date.now();
  }, []);

  return {
    t,
    ref
  };
};
